<template>
  <div>
    <memlist-modal size="lg" ref="campaign-edit-modal">
    
      <m-row>
        <m-col lg="12">
          <memlist-text-input
            id="id"
            name="id"
            :title="$t('MEMBER_RENEW_CAMPAIGN.ID')"
            layout="vertical"
            v-model="local_campaign.id"
            :disabled="true"
          />
        </m-col>
      </m-row>

      <m-row class="mt-4">
        <m-col lg="12">
          <memlist-text-input
            id="name"
            name="name"
            :title="$t('MEMBER_RENEW_CAMPAIGN.NAME')"
            layout="vertical"
            v-model="local_campaign.name"
            :required="true"
            :state="validate_state({ dirty: v$['local_campaign']['name'].$dirty, error: v$['local_campaign']['name'].$error })"
          />
        </m-col>

      </m-row>

      <!--<m-row class="mt-4">
        <m-col lg="12">
          <memlist-textarea
            id="descr"
            name="descr"
            :title="$t('MEMBER_RENEW_CAMPAIGN.DESCR')"
            layout="vertical"
            v-model="local_campaign.descr"
            rows="2"
          />
        </m-col>
      </m-row>-->

      <m-row class="mt-8" v-if="settings.is_mucf">
        <m-col lg="12">
          <QuestionRadioOptions
            group="type-options"
            :item="type_options"
            :preselected="local_campaign.type"
            @selected="type_selected"
          />
        </m-col>
      </m-row>

      <m-row class="mt-4">
        <m-col lg="3">
          <memlist-text-input
            height="40"
            id="num_members"
            name="num_members"
            :title="$t('MEMBER_RENEW_CAMPAIGN.NUM_MEMBERS')"
            layout="vertical"
            v-model="local_campaign.num_members"
            :disabled="true"
          />
        </m-col>
        <m-col lg="4">
          <memlist-modal size="lg" ref="search-modal">
            <AdvancedSearchViewMUCF
              :show_tabs="false"
              :show_continue_button="true"
              :show_refresh_button="false"
              :show_options_row="false"
              @on_search_result="on_search_result"
              @on_search_count_result="on_search_count_result"
              @on_continue_clicked="on_continue_clicked"
            />
          </memlist-modal>
          
          <memlist-button style="margin-top: 24px;" @click="select_members_clicked" variant="primary">{{ $t('MEMBER_RENEW_CAMPAIGN.SELECT_MEMBERS') }}</memlist-button>
        </m-col>
      </m-row>

      <m-row class="mt-4" v-if="show_period">
        <m-col lg="6">
          <memlist-select-input2
            layout="vertical"
            :title="$t('MEMBER_RENEW_CAMPAIGN.TO_PERIOD')"
            :items="period_options"
            v-model="local_campaign.to_period_id"
          />
        </m-col>
      </m-row>

      <m-row class="mt-4" v-if="show_error">
        <m-col lg="12">
          <p class="error">{{ $t('MEMBER_RENEW_CAMPAIGN.NO_MEMBERS_ERROR') }}</p>
        </m-col>
      </m-row>


      <RenewCampaignScheduledSendouts
        class="mt-16"
        v-if="local_campaign.id"
        :campaign_id="local_campaign.id"
      />
      
      <RightModalSaveAndCloseButtons
        class="mt-4"
        :text="creating ? $t('COMMON.NEXT') : $t('COMMON.SAVE')"
        :spin="true"
        @click="on_save_clicked"
        @close="on_close_clicked"
        ref="saveButton"
      />
    </memlist-modal>

  </div>
  
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { minLength, required, email, requiredIf } from '@vuelidate/validators';
// axios is REST API
import axios from 'axios';

// popup messages in the corner
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

// vuex state, storage
import { mapGetters } from 'vuex';
import AdvancedSearchViewMUCF from '@/view/pages/ml/advanced_search/AdvancedSearchViewMUCF.vue';
import QuestionRadioOptions from '@/view/components/questions/QuestionRadioOptions.vue';
import RenewCampaignScheduledSendouts from './RenewCampaignScheduledSendouts.vue';

export default {
  name: 'RenewCampaignEditorModal',
  mixins: [ toasts ],
  props: ['campaign_id'],
  emits: ['created', 'updated'],
  components: {
    AdvancedSearchViewMUCF,
    QuestionRadioOptions,
    RenewCampaignScheduledSendouts,
  },
  computed: {
    creating() {
      return !this.local_campaign.id;
    },
    period_options() {
      return this.periods.map(i => ({ text: i.name, value: i.id }));
    },
    show_period() {

      return false;/*
      if (this.periods.length === 0) {
        return false;
      }

      return true;*/
    },
    // which stored data we want to use
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'settings', 'periods'])
  },
  setup () {
    return { v$: useVuelidate() }
  },

  validations () {
    return {
      local_campaign: {
        name: { required },
      }
    }
  },
  mounted() {
    
    this.local_campaign = {
      to_period_id: this.currentPeriodId,
      type: 'RENEWAL',
    };
  },
  data() {
    return {
      type_options: {
        name: this.$t('MEMBER_RENEW_CAMPAIGN.TYPE'),
        options: [ 
          { value: 'RENEWAL', text: this.$t('MEMBER_RENEW_CAMPAIGN.TYPES.RENEWAL') }, 
          { value: 'CONFIRM', text: this.$t('MEMBER_RENEW_CAMPAIGN.TYPES.CONFIRM') },
          { value: 'ONECLICK', text: this.$t('MEMBER_RENEW_CAMPAIGN.TYPES.ONECLICK') } 
        ]
      },

      show_error: null,
      local_campaign: {},
    };
  },
  watch: {
    'local_campaign.num_members'(){
      if (this.local_campaign.num_members > 0) {
        this.show_error = null;
      }
    },
    campaign_id() {
      if (this.campaign_id) {
        this.fetch_campaign(this.campaign_id);
      }
      else {
        this.local_campaign = {
          to_period_id: this.currentPeriodId,
          type: 'RENEWAL',
        };
      }
    },
    currentCompanyId() {
      // triggers when user has changed company on top
      // we should reload content based on selected company
    },
    currentPeriodId() {
      // triggers when user has changed period on top
      // we should reload content based on period
    }

  },
  methods: {
    type_selected(data) {
      console.log('type_selected', data);
    },
    async create_campaign(item) {
      const res = await axios.post(`/member_renew/campaign`, item);

      if (res.status === 201) {
        return res.data;
      }

      this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('MEMBER_RENEW_CAMPAIGN.UNABLE_CREATE'));

      return null;
    },

    async update_campaign(item) {
      const res = await axios.put(`/member_renew/campaign/${item.id}`, item);

      if (res.status === 204) {
        return item;
      }

      this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('MEMBER_RENEW_CAMPAIGN.UNABLE_UPDATE'));

      return null;
    },

    select_members_clicked() {
      this.$refs['search-modal'].show();
    },

    on_search_result(search_options) {
      this.local_campaign.search_options = search_options;
    },

    on_search_count_result(count) {
      this.local_campaign.num_members = count;
      this.local_campaign = { ...this.local_campaign };
    },

    on_continue_clicked() {
      this.$refs['search-modal'].hide();
    },

    validate_state(state) {
      return state.dirty ? !state.error : null;
    },

    async on_save_clicked() {
      const valid = await this.v$.$validate();

      if (!valid) {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.FORM_VALIDATION_FAILED'));
        this.$refs['saveButton'].stop();
        return;
      }

      if (this.local_campaign.id) {
        const item = await this.update_campaign(this.local_campaign);

        if (item) {
          this.$emit('updated', item);
        }
      }
      else {

        if (!this.local_campaign.num_members) {
          this.show_error = 'no_members';
          this.$refs['saveButton'].stop();
          return;
        }

        const created = await this.create_campaign(this.local_campaign);

        if (created) {
          this.local_campaign = created;
          this.$emit('created', this.local_campaign);
        }
      }

      this.$refs['saveButton'].stop();
    },

    on_close_clicked() {
      this.hide();
    },

    async fetch_campaign(id) {
      const res = await axios.get(`/member_renew/campaign/${id}`);

      if (res.status === 200) {
        this.local_campaign = res.data;
      }
    },

    // add any methods we need
    show() {
      this.$refs['campaign-edit-modal'].show();
    },

    hide() {
      this.$refs['campaign-edit-modal'].hide();
    }
  }
};
</script>
